module.exports = __webpack_public_path__ + "img/projects.45ded11e.svg";